import { render } from "./ModalProduct.vue?vue&type=template&id=d6b23718&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=js"
export * from "./ModalProduct.vue?vue&type=script&lang=js"

import "./ModalProduct.vue?vue&type=style&index=0&id=d6b23718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b23718"]])

export default __exports__